import { render, staticRenderFns } from "./checkDialog.vue?vue&type=template&id=1c09775b&scoped=true&"
import script from "./checkDialog.vue?vue&type=script&lang=ts&"
export * from "./checkDialog.vue?vue&type=script&lang=ts&"
import style0 from "./checkDialog.vue?vue&type=style&index=0&id=1c09775b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c09775b",
  null
  
)

export default component.exports